// Angular
import {Directive, Output, EventEmitter, HostBinding, HostListener} from '@angular/core';

@Directive({
	selector: '[cvDragDropFile]'
})
export class DragAndDropFileDirective {

	@Output() filesDropped = new EventEmitter<any>();

	/**
	 * Dragover listener
	 * @param evt
	 */
	@HostListener('dragover', ['$event'])
	public onDragOver(event: any): void {
		event.preventDefault();
		event.stopPropagation();
	}

	/**
	 * Dragleave listener
	 * @param evt
	 */
	@HostListener('dragleave', ['$event'])
	public onDragLeave(event: any): void {
		event.preventDefault();
		event.stopPropagation();
	}

	/**
	 * Drop listener
	 * @param evt
	 */
	@HostListener('drop', ['$event'])
	public onDrop(event: any): void {
		event.preventDefault();
		event.stopPropagation();
		const files = event.dataTransfer.files;
		if (files.length > 0) {
			this.filesDropped.emit(files);
		}
	}

}
